import HeaderText from './HeaderText'

export default HeaderText
